import react, { useState } from "react";
import { Display } from "../../notebook/xCompo";

const SearchHighlighter = (props) => {
  let query = props.data.query;
  let searchRes = props.data.srchRes;

  return (
    <div className="extra-search-results">
      <div className="srch-res-stat">{searchRes.length} results found</div>
      <div className="srch-ress">
        {searchRes.map((d) => (
          <div className="srch-indi-res">
            <div className="srch-indi-res-topic">{d.name}</div>
            <div className="srch-indi-res-source">
              {d.cells.map((e) => (
                <Display data={{d:e}}/>
                // <div>{e.source}</div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SearchHighlighter;
